import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import ClickOutside from 'vuetify/lib/directives/click-outside';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VNavigationDrawer, {
    directives: [{
      def: ClickOutside,
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideDrawer,
      expression: "clickOutsideDrawer"
    }],
    attrs: {
      fixed: "",
      bottom: "",
      right: "",
      width: _vm.drawerWidth,
      temporary: ""
    },
    model: {
      value: _vm.drawer,
      callback: function callback($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }, [_c("div", {
    staticClass: "drawer"
  }, [_c("section", {
    staticClass: "drawer-header"
  }, [_c("div", {
    staticClass: "drawer-title"
  }, [_c(VBtn, {
    staticClass: "primary",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.close
    }
  }, [_c(VIcon, {
    attrs: {
      dark: ""
    }
  }, [_vm._v("mdi-close")])], 1), _c("h2", [_vm._v(_vm._s(_vm.order.reference_order.shorterReference()) + " to prepare")])], 1)]), !_vm.isContainerOrder && !_vm.order.expedition_method ? [_c("div", {
    staticClass: "mt-4 text-red"
  }, [_vm._v("Shipping type has not been chosen. It's required")])] : [_c(VStepper, {
    key: _vm.steps.length,
    attrs: {
      vertical: ""
    },
    model: {
      value: _vm.currentStep,
      callback: function callback($$v) {
        _vm.currentStep = $$v;
      },
      expression: "currentStep"
    }
  }, [_vm._l(_vm.steps, function (step) {
    var _vm$order$importer, _vm$itemsProvenanceNo, _vm$itemsProvenanceFr;
    return [_c("div", {
      key: "step_".concat(step.id)
    }, [_c(VStepperStep, {
      attrs: {
        step: step.id,
        complete: _vm.currentStep > step.id,
        rules: step.rules,
        editable: ""
      }
    }, [_vm._v(" " + _vm._s(step.title) + " "), _c("small", [_vm._v(_vm._s(step.inf))])]), step.key === "ttb" ? _c(VStepperContent, {
      attrs: {
        step: step.id
      }
    }, [_c("ul", _vm._l(_vm.winesWithoutTtbId, function (wine) {
      return _c("li", {
        key: wine.id_wine,
        staticClass: "text-sm text-left"
      }, [_c("router-link", {
        attrs: {
          to: {
            name: "userWineDetails",
            params: {
              id: wine.id_wine
            },
            query: {
              edit: true
            }
          },
          target: "_blank"
        }
      }, [_vm._v(" " + _vm._s(wine.display_name) + " ")])], 1);
    }), 0), _vm.winesWithoutTtbId.length ? _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        loading: _vm.isCheckingTtb
      },
      on: {
        click: _vm.checkWhetherAllTtbExists
      }
    }, [_vm._v(" Check updates ")]), _c("div", {
      staticClass: "text-left text-sm text-italic"
    }, [_vm._v(_vm._s(_vm.ttbStepTip))])], 1) : _vm._e()]) : _vm._e(), step.key === "importer" ? _c(VStepperContent, {
      attrs: {
        step: step.id
      }
    }, [_c("div", {
      staticClass: "text-left"
    }, [!_vm.isEditingImporter ? [_c("strong", [_vm._v(" « " + _vm._s(_vm.order.importer && _vm.order.importer.id > 0 ? _vm.order.importer.name : "No importer") + " » ")]), _vm.canEditImporter ? _c("a", {
      staticClass: "ml-2 text-sm",
      attrs: {
        href: "#"
      },
      on: {
        click: function click() {
          _vm.isEditingImporter = true;
        }
      }
    }, [_vm._v(" Change ")]) : _vm._e()] : _c("div", {
      staticClass: "d-flex"
    }, [_c(VAutocomplete, {
      attrs: {
        items: _vm.importersAvailable,
        "item-value": "id",
        "item-text": "name",
        "return-object": "",
        label: "Importer",
        "hide-details": "auto"
      },
      model: {
        value: _vm.importerSelectorSelected,
        callback: function callback($$v) {
          _vm.importerSelectorSelected = $$v;
        },
        expression: "importerSelectorSelected"
      }
    }), _c("div", {
      staticClass: "mt-3"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small",
      attrs: {
        disabled: !_vm.importerSelectorSelected
      },
      on: {
        click: _vm.saveChangeImporter
      }
    }, [_vm._v(" Save ")])], 1)], 1), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        disabled: !((_vm$order$importer = _vm.order.importer) !== null && _vm$order$importer !== void 0 && _vm$order$importer.id)
      },
      on: {
        click: function click($event) {
          return _vm.confirmStep();
        }
      }
    }, [_vm._v(" Continue ")])], 1)], 2)]) : _vm._e(), step.key === "pickup" ? _c(VStepperContent, {
      key: "pickup_".concat(step.id),
      attrs: {
        step: step.id
      }
    }, [_vm.errorOccurred ? _c("p", {
      staticClass: "errorLabel text-sm text-center"
    }, [_vm._v(" No date has been selected! ")]) : _vm._e(), !_vm.slots.length ? _c(VSkeletonLoader, {
      staticStyle: {
        width: "100%"
      },
      attrs: {
        type: "image"
      }
    }) : _c("div", {
      staticClass: "date-picker"
    }, [_c(VDatePicker, {
      attrs: {
        disabled: _vm.isValidatingOrder,
        "data-cy": "prepare-order-date-picker"
      },
      on: {
        input: _vm.inputDate
      },
      model: {
        value: _vm.form.slots[step.data.id_order],
        callback: function callback($$v) {
          _vm.$set(_vm.form.slots, step.data.id_order, $$v);
        },
        expression: "form.slots[step.data.id_order]"
      }
    })], 1), _vm.hasWarningAboutPricePostingUsed ? _c("div", {
      staticClass: "mt-3 text-left"
    }, [_c(VAlert, {
      staticClass: "--small",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "red",
        text: ""
      },
      on: {
        click: _vm.close
      }
    }, [_c("div", {
      domProps: {
        innerHTML: _vm._s(_vm.warningAboutPricePostingUsedHtml)
      }
    })])], 1) : _vm._e(), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        "data-cy": "step-plan-a-pickup-continue-btn"
      },
      on: {
        click: function click($event) {
          return _vm.confirmPickup(_vm.form.slots[step.data.id_order]);
        }
      }
    }, [_vm._v(" Continue ")])], 1)], 1) : _vm._e(), step.key === "shipment" ? _c(VStepperContent, {
      key: "shipment_".concat(step.id),
      attrs: {
        step: step.id
      }
    }, [_c("OrderShipmentList", {
      ref: "prepareDrawerOrderShipmentRef",
      refInFor: true,
      attrs: {
        order: _vm.order,
        withAddbutton: ""
      },
      on: {
        shipmentsChanged: _vm.shipmentsChanged
      }
    }), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        "data-cy": "step-tracking-continue-btn"
      },
      on: {
        click: _vm.confirmStep
      }
    }, [_vm._v(" Continue ")])], 1)], 1) : _vm._e(), step.key === "containerSuborders" ? _c(VStepperContent, {
      key: "shipment_".concat(step.id),
      attrs: {
        step: step.id
      }
    }, [_c("div", [_c("div", {
      staticClass: "d-flex align-center"
    }, [_c(VSwitch, {
      staticClass: "mt-0",
      attrs: {
        "hide-details": "auto"
      },
      model: {
        value: _vm.isAutoStatusContainerSuborders,
        callback: function callback($$v) {
          _vm.isAutoStatusContainerSuborders = $$v;
        },
        expression: "isAutoStatusContainerSuborders"
      }
    }), !_vm.isAutoStatusContainerSuborders ? _c("span", {
      staticClass: "text-red text-bold"
    }, [_vm._v(" WILL NOT UPDATE SUBORDERS STATUS TO IN PREPARATION ")]) : _c("span", {
      staticClass: "text-green text-bold"
    }, [_vm._v(" Will try to update suborders status to in preparation without notifying any third person ")])], 1)]), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary"
      },
      on: {
        click: _vm.confirmStep
      }
    }, [_vm._v("Continue")])], 1)]) : _vm._e(), step.key === "mail" ? _c(VStepperContent, {
      key: "mail_".concat(step.id),
      attrs: {
        step: step.id
      }
    }, [!!_vm.order.warehouseMail ? _c("div", {
      staticClass: "mail-container"
    }, [_c(VTextField, {
      attrs: {
        label: "Warehouse mail",
        disabled: true,
        "hide-details": "auto"
      },
      model: {
        value: _vm.order.warehouseMail,
        callback: function callback($$v) {
          _vm.$set(_vm.order, "warehouseMail", $$v);
        },
        expression: "order.warehouseMail"
      }
    }), _c("div", {
      staticClass: "mail-icons"
    }, [_c(VTooltip, {
      attrs: {
        top: ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref) {
          var on = _ref.on,
            attrs = _ref.attrs;
          return [_c(VIcon, _vm._g(_vm._b({
            attrs: {
              small: ""
            },
            on: {
              click: function click($event) {
                return _vm.copyToClipboard(_vm.order.warehouseMail);
              }
            }
          }, "v-icon", attrs, false), on), [_vm._v(" far fa-clipboard ")])];
        }
      }], null, true)
    }, [!_vm.isCopyingToClipboard ? _c("span", [_vm._v("Copy to clipboard")]) : _vm._e(), _vm.isCopyingToClipboard ? _c("div", [_c(VIcon, {
      staticStyle: {
        color: "green"
      }
    }, [_vm._v("mdi-check")]), _vm._v(" Copied ")], 1) : _vm._e()])], 1)], 1) : _vm._e(), _c(VExpansionPanels, {
      on: {
        change: _vm.changePanel
      },
      model: {
        value: _vm.openedPanel,
        callback: function callback($$v) {
          _vm.openedPanel = $$v;
        },
        expression: "openedPanel"
      }
    }, _vm._l(_vm.form.emailTemplates, function (emailTemplate, i) {
      return _c(VExpansionPanel, {
        key: "expansion-panel_".concat(i),
        attrs: {
          id: "expansion-panel_".concat(i)
        }
      }, [_c(VExpansionPanelHeader, [_c(VBtn, {
        staticClass: "expansion-panel-header-close-btn",
        attrs: {
          icon: "",
          "data-cy": "step-mail-close-btn"
        },
        on: {
          click: function click($event) {
            return _vm.deleteTemplatePanel(i);
          }
        }
      }, [_c(VIcon, [_vm._v("mdi-close")])], 1), _vm._v(" " + _vm._s(emailTemplate.name) + " ")], 1), _c(VExpansionPanelContent, [!_vm.flattenPlaceholders.length ? _c(VSkeletonLoader, {
        staticStyle: {
          width: "100%"
        },
        attrs: {
          type: "image"
        }
      }) : [_vm.isNeedingSync ? _c(VBtn, {
        staticClass: "sync-btn",
        attrs: {
          rounded: "",
          loading: _vm.isSyncing
        },
        on: {
          click: _vm.syncLatestVersion
        }
      }, [_c(VIcon, [_vm._v("mdi-lightning-bolt")]), _vm._v(" Sync latest version ")], 1) : _vm._e(), _vm.openedPanel === i ? _c("MailTemplateForm", {
        key: "step_template_".concat(emailTemplate.id, "_").concat(i),
        attrs: {
          order: _vm.order,
          placeholders: _vm.emailPlaceholders,
          templates: _vm.emailTemplates,
          documents: _vm.documents,
          isDeletingTemplate: _vm.isDeletingTemplate
        },
        on: {
          edit: _vm.editTemplate,
          delete: _vm.deleteTemplate,
          change: _vm.changeTemplate,
          "click:new": _vm.newTemplate,
          "click:placeholder": _vm.clickPlaceholder
        },
        model: {
          value: _vm.form.emailTemplates[i],
          callback: function callback($$v) {
            _vm.$set(_vm.form.emailTemplates, i, $$v);
          },
          expression: "form.emailTemplates[i]"
        }
      }) : _vm._e()]], 2)], 1);
    }), 1), _c(VBtn, {
      staticClass: "new-email-btn",
      attrs: {
        rounded: ""
      },
      on: {
        click: _vm.newEmail
      }
    }, [_c(VIcon, [_vm._v("mdi-plus")]), _vm._v(" new e-mail ")], 1), _c(VDivider), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        "data-cy": "step-mail-continue-btn"
      },
      on: {
        click: _vm.confirmStep
      }
    }, [_vm._v(" Continue ")])], 1)], 1) : _vm._e(), step.key === "synthesis" ? _c(VStepperContent, {
      attrs: {
        step: step.id
      }
    }, [_vm.isInvalidMainForm ? _c("div", {
      staticClass: "errorLabel text-sm"
    }, [_c("p", [_vm._v("Make sure you have completed all the previous step.")]), _vm._l(_vm.errorsMainForm, function (error, i) {
      return _c("div", {
        key: "mainError-".concat(i)
      }, [_vm._v(" " + _vm._s(error) + " ")]);
    })], 2) : _vm._l(Object.keys(_vm.form.slots), function (orderId, i) {
      return _c("div", {
        key: "slot_".concat(i),
        staticClass: "text-left pb-2"
      }, [_vm.order.expedition_method !== _vm.expeditionMethods.CELLAR_STORAGE.id ? _c("div", [_vm._v(" Pickup date scheduled for "), _c("strong", [_vm._v(" " + _vm._s(new Intl.DateTimeFormat("en-US", {
        dateStyle: "long"
      }).format(new Date(_vm.form.slots[orderId]))) + " ")])]) : _c("div", {
        staticClass: "reminder-text text-italic"
      }, [_vm._v(" Reminder: As the customer has chosen the cellar storage option, you do not have to deal with a transporter/pick-up. ")]), _vm.isContainerOrder ? _c("div", {
        staticClass: "mt-2"
      }, [_vm._v(" Container suborders "), _c("div", {
        staticClass: "d-flex align-center"
      }, [_c(VSwitch, {
        staticClass: "mt-0",
        attrs: {
          "hide-details": "auto"
        },
        model: {
          value: _vm.isAutoStatusContainerSuborders,
          callback: function callback($$v) {
            _vm.isAutoStatusContainerSuborders = $$v;
          },
          expression: "isAutoStatusContainerSuborders"
        }
      }), !_vm.isAutoStatusContainerSuborders ? _c("span", {
        staticClass: "text-red text-bold"
      }, [_vm._v(" WILL NOT UPDATE SUBORDERS STATUS TO IN PREPARATION ")]) : _c("span", {
        staticClass: "text-green text-bold"
      }, [_vm._v(" Will try to update suborders status to in preparation without notifying any third person ")])], 1)]) : _vm._e(), _c("div", {
        staticClass: "mt-4 text-left"
      }, [_c("div", {
        staticClass: "text-smaller text-italic"
      }, [_vm._v(" Mail title : Order has been validated ")]), _c("div", {
        staticClass: "d-flex align-center"
      }, [_c(VSwitch, {
        staticClass: "mt-0",
        attrs: {
          "hide-details": "auto"
        },
        model: {
          value: _vm.isSendNotificationMails,
          callback: function callback($$v) {
            _vm.isSendNotificationMails = $$v;
          },
          expression: "isSendNotificationMails"
        }
      }), !_vm.isSendNotificationMails ? _c("span", {
        staticClass: "text-red text-bold"
      }, [_vm._v(" WILL NOT NOTIFY THE CUSTOMER BY AUTOMATIC PLATFORM MAIL ")]) : _c("span", {
        staticClass: "text-green text-bold"
      }, [_vm._v(" Will notify customer by automatic platform mail ")])], 1)]), _vm.hasImporter ? _c("div", {
        staticClass: "mt-4"
      }, [_c("div", {
        staticClass: "text-smaller text-italic"
      }, [_vm._v(" Mail title : Order has been validated and being prepared ")]), _c("div", {
        staticClass: "d-flex align-center"
      }, [_c(VSwitch, {
        staticClass: "mt-0",
        attrs: {
          "hide-details": "auto",
          disabled: !_vm.importerSelectedHasMail
        },
        model: {
          value: _vm.isSendNotificationMailsToImporter,
          callback: function callback($$v) {
            _vm.isSendNotificationMailsToImporter = $$v;
          },
          expression: "isSendNotificationMailsToImporter"
        }
      }), !_vm.isSendNotificationMailsToImporter ? [_vm.importerSelectedHasMail ? _c("span", {
        staticClass: "text-red"
      }, [_vm._v(" WILL NOT send any email to the IMPORTER ")]) : _c("span", {
        staticClass: "text-red text-italic"
      }, [_vm._v(" The importer has no mail configured ")])] : _c("span", {
        staticClass: "text-green"
      }, [_vm._v(" Will send an email to the IMPORTER with the order confirmation attached ")])], 2), !!_vm.form.emailTemplates.length ? _c("div", {
        staticClass: "mt-8"
      }, [_c("i", {
        staticClass: "fas fa-envelope mr-1"
      }), _vm._v(" Email(s) "), _c("strong", [_vm._v("(x" + _vm._s(_vm.form.emailTemplates.length) + ")")]), _vm._l(_vm.form.emailTemplates, function (emailTemplate, i) {
        return _c("div", {
          key: "synthesis_template_".concat(emailTemplate.id),
          staticClass: "text-sm"
        }, [_c(VDivider, {
          staticClass: "my-3"
        }), _c("div", {
          staticClass: "synthesis-email-line"
        }, [_c("div", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.isSuccessfulSending["".concat(emailTemplate.id, "_").concat(i)],
            expression: "isSuccessfulSending[`${emailTemplate.id}_${i}`]"
          }],
          staticClass: "sent-container"
        }, [_c("svg", {
          attrs: {
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 130.2 130.2"
          }
        }, [_c("circle", {
          staticClass: "path circle",
          attrs: {
            fill: "none",
            stroke: "#73AF55",
            "stroke-width": "6",
            "stroke-miterlimit": "10",
            cx: "65.1",
            cy: "65.1",
            r: "62.1"
          }
        }), _c("polyline", {
          staticClass: "path check",
          attrs: {
            fill: "none",
            stroke: "#73AF55",
            "stroke-width": "6",
            "stroke-linecap": "round",
            "stroke-miterlimit": "10",
            points: "100.2,40.2 51.5,88.8 29.8,67.5 "
          }
        })]), _vm._v(" Sent! ")]), _c("div", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.failedCustomMails["".concat(emailTemplate.id, "_").concat(i)],
            expression: "failedCustomMails[`${emailTemplate.id}_${i}`]"
          }],
          staticClass: "sent-container text-center"
        }, [_c("svg", {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            viewBox: "0 0 150.2 150.2"
          }
        }, [_c("path", {
          staticClass: "path",
          attrs: {
            d: "M 10,10 l 90,90 M 100,10 l -90,90",
            stroke: "red",
            "stroke-width": "10"
          }
        })]), _vm._v(" Not sent! ")]), _c("div", [_c("div", {
          staticClass: "mt-1"
        }, [_c("strong", [_vm._v(_vm._s(emailTemplate.name) + ":")])]), _c("div", {
          staticClass: "text-italic mb-1",
          staticStyle: {
            "font-size": "1rem"
          }
        }, [_vm._v(" " + _vm._s(emailTemplate.from) + " "), _c("i", {
          staticClass: "fas fa-paper-plane mx-2",
          staticStyle: {
            "font-size": "0.85rem"
          }
        }), _vm._v(" " + _vm._s(emailTemplate.sendTo && emailTemplate.sendTo.join(", ")) + " ")]), _c("div", {
          staticClass: "text-italic"
        }, _vm._l(emailTemplate.files, function (file) {
          return _c("a", {
            key: "file_".concat(file.id, "_").concat(file.name),
            staticClass: "mr-2",
            attrs: {
              href: !!file.blob ? file.url : _vm.URL.createObjectURL(file),
              target: "_blank"
            }
          }, [_c("i", {
            staticClass: "fas fa-paperclip"
          }), _vm._v(" " + _vm._s(file.id || file.name) + " ")]);
        }), 0)])])], 1);
      })], 2) : _c("div", {
        staticClass: "errorLabel mt-3"
      }, [_vm._v(" No custom mail has been configured. Are you sure to continue ? ")])]) : _vm._e()]);
    }), _vm.hasWarningItemsProvenanceAboutInvoice ? _c("div", {
      staticClass: "mt-3 text-left"
    }, [!_vm.showDetailsOfItemsProvenanceAboutInvoice ? _c(VAlert, {
      staticClass: "--small cursor--pointer",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "orange",
        text: ""
      },
      on: {
        click: function click($event) {
          _vm.showDetailsOfItemsProvenanceAboutInvoice = true;
        }
      }
    }, [_vm._v(" It appears there might be a potential accounting issue with some items. "), _c("br"), _vm._v(" Please ensure that the order complies with all applicable laws. "), _c("br"), _vm._v(" Click here to see details for verification. ")]) : [_vm.order.isPreventInvoice && ((_vm$itemsProvenanceNo = _vm.itemsProvenanceNotFromOrder) === null || _vm$itemsProvenanceNo === void 0 ? void 0 : _vm$itemsProvenanceNo.length) > 0 ? _c(VAlert, {
      staticClass: "--small",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "orange",
        text: ""
      }
    }, [_c("div", [_vm._v(" Some items are not linked to a previous invoice, which may result in accounting issues. "), _c("br"), _vm._v(" Please ensure that the order complies with all applicable laws. ")]), _vm._l(_vm.itemsProvenanceNotFromOrder, function (item) {
      return _c("div", {
        key: "alert-provenance-invoice-" + item.id_item
      }, [_vm._v(" - " + _vm._s("".concat(item.quantity, " b. of ").concat(item.wine.naming_data.sku)) + " "), _c("span", {
        staticClass: "text-smaller text-italic"
      }, [_vm._v(" (" + _vm._s(_vm.wineNaming(_vm.$whitelabel, item.wine.naming_data, true, true)) + ") ")])]);
    })], 2) : !_vm.order.isPreventInvoice && ((_vm$itemsProvenanceFr = _vm.itemsProvenanceFromOrder) === null || _vm$itemsProvenanceFr === void 0 ? void 0 : _vm$itemsProvenanceFr.length) > 0 ? _c(VAlert, {
      staticClass: "--small",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "orange",
        text: ""
      }
    }, [_c("div", [_vm._v(" Some items are already linked to a previous invoice, which may result in accounting issues. "), _c("br"), _vm._v(" Please ensure that the order complies with all applicable laws. ")]), _vm._l(_vm.itemsProvenanceFromOrder, function (item) {
      return _c("div", {
        key: "alert-provenance-invoice-" + item.id_item
      }, [_vm._v(" - " + _vm._s("".concat(item.quantity, " b. of ").concat(item.wine.naming_data.sku)) + " "), _c("span", [_vm._v(" (" + _vm._s(_vm.wineNaming(_vm.$whitelabel, item.wine.naming_data, true, true)) + ") ")])]);
    })], 2) : _vm._e()]], 2) : _vm._e(), _vm.hasWarningAboutPricePostingUsed ? _c("div", {
      staticClass: "mt-3 text-left"
    }, [_c(VAlert, {
      staticClass: "--small",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "red",
        text: ""
      },
      on: {
        click: _vm.close
      }
    }, [_c("div", {
      domProps: {
        innerHTML: _vm._s(_vm.warningAboutPricePostingUsedHtml)
      }
    })])], 1) : _vm._e(), _c(VExpandTransition, [_vm.hasFailedSending ? _c(VAlert, {
      staticClass: "--error my-2",
      attrs: {
        type: "error",
        outlined: "",
        dense: ""
      }
    }, [_vm._v(' Some custom emails were not sent! You must use the button "Send mail" on top of order details to resend them. ')]) : _vm._e()], 1), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        loading: _vm.isValidatingOrder,
        disabled: _vm.isInvalidMainForm || _vm.hasFailedSending,
        "data-cy": "step-synthesis-continue-btn"
      },
      on: {
        click: _vm.validateMain
      }
    }, [_vm._v(" " + _vm._s(_vm.form.emailTemplates.length > 0 ? "Save & Send" : "Save") + " ")])], 1), _vm.isContainerOrder && _vm.isValidatingOrder ? _c("div", {
      staticClass: "text-smaller text-italic text-left"
    }, [_vm._v(" It may take a while, please wait a moment ")]) : _vm._e()], 2) : _vm._e()], 1)];
  })], 2)]], 2), _vm.templateModalShown ? _c("MailTemplateModal", {
    attrs: {
      shown: _vm.templateModalShown,
      placeholders: _vm.emailPlaceholders,
      template: _vm.editableTemplate
    },
    on: {
      save: _vm.saveTemplate,
      close: _vm.closeTemplateModal
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };